import { DEPLOY_ENV, VERSION } from './config';
import { getCompanyUid, getIsCypressMode, getLanguageId } from './globals';
export function setupBugTracking() {
    if (process.env.NODE_ENV !== 'production' ||
        DEPLOY_ENV !== 'production' ||
        getIsCypressMode())
        return;
    if (!window.Sentry)
        return;
    window.Sentry.onLoad(() => {
        window.Sentry.init({
            environment: DEPLOY_ENV,
            release: `elevio-kb@${VERSION}`,
            attachStacktrace: true,
            ignoreErrors: ['ResizeObserver loop limit exceeded'],
            beforeSend: (event, hint) => {
                var _a, _b, _c;
                const isInClientsHTML = 
                // @ts-ignore
                (_b = (_a = hint.originalException) === null || _a === void 0 ? void 0 : _a.stack) === null || _b === void 0 ? void 0 : _b.match(/elevioAddScriptInner/);
                if (!!isInClientsHTML)
                    return null;
                // Ingore errors from third party scripts.
                // @ts-ignore
                const filename = (_c = hint.originalException) === null || _c === void 0 ? void 0 : _c.fileName;
                const host = window.location.host;
                if (filename &&
                    !(filename.includes(host) ||
                        filename.includes('cdn.elev.io') ||
                        filename.includes('cdn.elev-staging.com'))) {
                    return null;
                }
                // Ignore errors from the Assistant
                if (filename && filename.includes('elevio-main.js')) {
                    return null;
                }
                // NOTE: put customer hook here, if they want to be notified about errors.
                return event;
            },
        });
        window.Sentry.configureScope((scope) => {
            scope.setTag('company_uid', getCompanyUid());
            scope.setTag('page_locale', getLanguageId());
        });
    });
}
export function reportError(err) {
    if (err instanceof Error)
        return;
    if (process.env.NODE_ENV !== 'production' || getIsCypressMode()) {
        console.error(err);
        return;
    }
    if (!window.Sentry)
        return;
    window.Sentry.captureException(err);
}
export function addBreadCrumb(crumb) {
    if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test')
        return;
    if (!window.Sentry)
        return;
    window.Sentry.addBreadcrumb({
        ...crumb,
        level: crumb.level || 'log',
    });
}
//# sourceMappingURL=bugTracking.js.map